import React from "react";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../../molecules/UnderlinedHeader/UnderlinedHeader";
import useSmallNav from "../../../../hooks/useSmallNav";
import InfoHero from "../../../molecules/info/InfoHero/InfoHero";
import InfoGrid from "../../../atoms/info/InfoGrid/InfoGrid";
import InfoHeader from "../../../atoms/info/InfoHeader/InfoHeader";
import InfoCard from "../../../molecules/info/InfoCard/InfoCard";
import pajero from "./../../../../assets/info/pajero-hero.jpg";
import ride from "./../../../../assets/info/mitsubishi-pajero/ride-height-diagram-spaced_1_.jpg";
import { popularVehicle } from "../../../../vars/popularVehicles";
import InfoFooter from "../../../organisms/InfoFooter/InfoFooter";

const MitsubishiPajero = () => {
  useSmallNav("Mitsubishi Pajero");

  return (
    <section className={"popular"}>
      <Container>
        <UnderlinedHeader text={"Mitsubishi Pajero"} bolder />
        <InfoHero image={pajero} />
        <InfoGrid>
          <div>
            <p>
              Trak Ryder 4WD Suspension represents many years of technical
              development and delivers new levels of ride and comfort for the
              4-wheel drive Mitsubishi Pajero owner. Pedders Trak Ryder
              suspension includes hundreds of quality components in its
              construction each designed to improve the ride and handling of
              specific vehicles in specific ways.
            </p>
            <InfoHeader text={"So which one do I want?"} smaller />
            <p>
              Well that rather depends on what you aim to achieve. For those
              simply seeking replacement parts to replace worn originals, you
              will see we offer a comprehensive range of quality parts. For
              those with the optional electronically adjustable suspension, we
              do not offer a replacement for this at this time. These are only
              available from Mitsibushi. It is possible to fit our dampers to
              vehicles fitted with adjustable suspension, but this would
              eliminate the adjustable function.
            </p>
            <p>
              If you are looking to increase the height of your vehicle, or
              carry greater loads, then again, we have what you need. We offer
              various springs and dampers for your Pajero. To save hunting round
              for the right parts, we have put together lift kits for you. An
              added bonus is that purchasing them this way will save you money!
            </p>
            <p>
              All the kits include front and rear springs (torsion bars where
              applicable) and 4 of our fantastic Foam Cell Dampers. For full
              details and benefits of foam cell technology from Pedders, click
              here.
            </p>
            <InfoHeader
              text={"Surely I can just wind up my torsion bars?"}
              size="smaller"
            />
            <p>
              Well, of course this is correct. However with most older Pajeros
              you will find, just like any spring, that the torsion bars have
              settled. Most often, winding them gives only a short term
              improvement. In addition of course our torsion bars use a
              different spring rate (as do our springs) designed to work in
              harmony with our dampers.
            </p>
            <InfoHeader
              text={"Is everything I need included in the kit?"}
              size="smaller"
            />
            <p>
              Yes, it certainly is. Where applicable, dampers come complete with
              replacement bushes etc. We do of course offer additional parts
              such as upgraded bushes for your Pajero.
            </p>
            <InfoHeader text={"How high will my Pajero be?"} smaller />
            <p>
              Although the kits give an approximate lift, this can be a little
              misleading. As mentioned above, springs settle over time, so a 1.5
              inch lift, may turn out to be a bit more in reality. To ensure
              that you know exactly what you are getting, we also quote a fitted
              height.
            </p>
            <img src={ride} alt={"How high will my Pajero be?"} />
            <p>
              This is measured from the bottom of the wheel rim to the
              wheel-arch. The benefit of this method is that tyre choice has no
              influence on the quoted height. The diagram to the left
              illustrates a ride height of 715mm with 17" wheels.
            </p>
            <p>
              Still not sure we have the right parts? Not sure which kit is the
              one for you? Then please get in touch, where one of our team will
              ensure you get the right parts for your needs.
            </p>
            <iframe
              title={"Mitsubishi Pajero Video 1"}
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/g1aSCo4S2_E"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
          <div>
            {popularVehicle
              .find((e) => e.make === "Mitsubishi")
              .models.find((e) => e.display === "Pajero & Shogun")
              .popular.map((item) => (
                <InfoCard
                  key={item.text}
                  name={item.text}
                  to={item.link}
                  photo={item.photo}
                />
              ))}
            <iframe
              title={"Mitsubishi Pajero Video 2"}
              width="100%"
              height="315"
              src="https://www.youtube.com/embed/lCMrIc_WS7s"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              title={"Mitsubishi Pajero Video 3"}
              width="100%"
              height="315"
              src="https://www.youtube.com/embed/KnT6sI4QaYk"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </InfoGrid>
        <InfoFooter make="Mitsubishi" model="Shogun & Pajero" />
      </Container>
    </section>
  );
};

export default MitsubishiPajero;
